/* eslint-disable prettier/prettier */
import { Box, Typography, Avatar } from "@mui/material";
import styled from "styled-components";
import Colors from "@constants/Colors";

export const StyledTypography = styled(Typography)<{
  selected: boolean;
  notification?: string;
}>`
  color: ${({ selected }: { selected: boolean }) =>
    selected ? Colors.primary : ""};
  font-family: ${({ selected }: { selected: boolean }) =>
    selected ? "Ringside Regular-Bold" : "Ringside Regular-Book"} !important;
  font-weight: ${({ selected }: { selected: boolean }) =>
    selected ? 400 : 325} !important;
  font-size: ${({ selected }: { selected: boolean }) =>
    selected ? "18px" : "16px"} !important;
  line-height: 24px !important;
  width: ${({ notification }: { notification?: string }) =>
    notification === "true" ? "calc(100% - 99px)" : "100%"};
`;

export const StyledIcon = styled("img")<{ selected: boolean }>`
  filter: ${({ selected }: { selected: boolean }) =>
    selected
      ? "invert(38%) sepia(73%) saturate(393%) hue-rotate(193deg) brightness(83%) contrast(100%)"
      : ""};
  height: 24px;
  width: 24px;
`;

export const StyledBox = styled(Box)<{ selected: boolean; header: string }>`
  background-color: ${(props) =>
    props.selected ? Colors.neutral_gray_100 : ""};
  padding: 12px 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 24px;
  cursor: ${(props) => (props.header === "true" ? "" : "pointer")};
`;

export const StyledAvatar = styled(Avatar)`
  max-width: 35px !important;
  max-height: 35px !important;
  background: ${Colors.primary}!important;
  border-radius: 100px;
  font-size: 14px !important;
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  margin-right: 16px !important;
`;

export const StyledRootBox = styled(Box)<{
  selected: boolean;
  header: string;
}>`
  background-color: ${(props) =>
    props.selected ? Colors.neutral_gray_100 : ""};
  border-radius: 8px;
  display: flex;
  align-items: center;

  gap: 24px;
  cursor: ${(props) => (props.header === "true" ? "" : "pointer")};
  justify-content: space-between;
  .MuiButtonBase-root {
    color: ${({ selected }: { selected: boolean }) =>
    selected ? Colors.primary : Colors.black};
    font-family: ${({ selected }: { selected: boolean }) =>
    selected ? "Ringside Regular-Bold" : "Ringside Regular-Book"} !important;
    font-weight: ${({ selected }: { selected: boolean }) =>
    selected ? 400 : 325} !important;
    font-size: ${({ selected }: { selected: boolean }) =>
    selected ? "18px" : "16px"} !important;
    letter-spacing: 0;
    text-transform: none;
    line-height: 24px !important;
    &:hover {
      background-color: transparent;
    }
  }
`;

export const StyledTextBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 12px 16px;
`;
